/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { getHighlightedPhoto } from '../../lib/photo.mjs'
import NoPhoto from '../NoPhoto'
import { Image } from '@mantine/core'

export type EstatePhotoProps = {
  photos?: Partial<EstatePhoto>[],
  height?: number,
  width?: number
}

function EstatePhoto (props: EstatePhotoProps) {
  const {
    photos,
    height = 90,
    width,
    ...others
  } = props

  const highlightedPhoto = useMemo(() => (
    getHighlightedPhoto(photos || []) ||
    (photos || [])[0]
  ), [photos])

  return highlightedPhoto != null
    ? <Image
      bg="gray.0"
      radius="md"
      alt={highlightedPhoto.name}
      src={highlightedPhoto.url}
      h={height}
      w={width}
      {...others}
    />
    : <NoPhoto
      width={width}
      height={height}
      {...others}
    />
}

export default EstatePhoto
